export default __webpack_public_path__ + "static/media/crossroads2.697681a4.webp";